import { render, staticRenderFns } from "./returnImagesUpload.vue?vue&type=template&id=4d738b57&scoped=true"
import script from "./returnImagesUpload.vue?vue&type=script&lang=js"
export * from "./returnImagesUpload.vue?vue&type=script&lang=js"
import style0 from "./returnImagesUpload.vue?vue&type=style&index=0&id=4d738b57&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d738b57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d738b57')) {
      api.createRecord('4d738b57', component.options)
    } else {
      api.reload('4d738b57', component.options)
    }
    module.hot.accept("./returnImagesUpload.vue?vue&type=template&id=4d738b57&scoped=true", function () {
      api.rerender('4d738b57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/returnImagesUpload.vue"
export default component.exports